/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：239
 */

module.exports = {
  hide: "style_hide__2a1hr",
  "coco-widget-wrapper": "style_coco-widget-wrapper__35_O4",
  "coco-child-widget": "style_coco-child-widget__90_t5",
  "coco-child-widget-selected": "style_coco-child-widget-selected__2cA3V",
  "coco-child-widget-full": "style_coco-child-widget-full__1j-Ia",
  textWidget: "style_textWidget__3r2dO",
  "coco-editable": "style_coco-editable__2C6ln",
  content: "style_content__1QoMj"
}
